import { ShortcutHelper } from '@/services/helpers/ShortcutHelper'
export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const token = localStorage.getItem('auth-token')
  if (token) {
    userStore.editable.token = token
  }
  const currentTenant = localStorage.getItem('current-tenant')
  if (currentTenant) {
    userStore.editable.currentTenantId = currentTenant
  }
  const { isMobileDevice, isAppOrWebWithMobile, addDeepLinking, inviteToDownloadIfMobileBrowser } = useDeviceStore()
  isMobileDevice()
  isAppOrWebWithMobile()
  addDeepLinking()
  ShortcutHelper.init()
  inviteToDownloadIfMobileBrowser()
})
